export const DEFAULT_OUTPUT_FORMAT = 'docx';

export const OUTPUT_FORMATS = [
    { value: 'docx', label: 'DOCX' },
    { value: 'md', label: 'MD' },
    { value: 'pdf', label: 'PDF' },
    { value: 'txt', label: 'TXT' },
];

export const DEFAULT_TEXT_ACCERT = {
    'text/plain': ['.txt'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/pdf': ['.pdf'],
    'text/markdown': ['.md'],
};

export const DEFAULT_AUDIO_ACCERT = {
    'audio/mp3': ['.mp3'],
    'audio/wav': ['.wav'],
    'audio/aac': ['.aac'],
    'audio/ogg': ['.ogg'],
    'audio/flac': ['.flac'],
    'audio/x-m4a': ['.m4a'],
    'video/webm': ['.webm'],
    'video/mp4': ['.mp4'],
    'video/x-matroska': ['.mkv'],
};